import { useEffect } from 'react';

interface ScriptOption {
    src: string;
    onLoad?: Function;
    enabled?: boolean;
    id?: string;
}

function useScript({
    src, onLoad, enabled = true, id,
}:ScriptOption) {
    useEffect(() => {
        if (enabled && src) {
            if (id) {
                const exists = document.querySelector(`#${id}`);
                if (exists) {
                    return;
                }
            } else {
                const exists = document.querySelector(`script[src="${src}"]`);
                if (exists) {
                    return;
                }
            }
            const script = document.createElement('script');
            if (id) {
                script.id = id;
            }
            if (onLoad) {
                script.onload = () => onLoad();
            }
            document.head.appendChild(script);
            script.src = src;
        }
    }, [src, onLoad, enabled]);
}

export default useScript;
